import { createContext } from 'react';
import type { ExportType, Transcription } from '../../entities';

export interface IExportTranscriptionContextValue {
    isDownloadingExportFile: boolean,
    exportErrorMessage: string | null,
    onDownload: (transcription: Transcription, type: ExportType) => void;
    clearError: () => void;
}

export const ExportTranscriptionContextDefaultValue: IExportTranscriptionContextValue = {
  isDownloadingExportFile: false,
  exportErrorMessage: null,
  onDownload: () => { throw Error('Missing ExportTranscriptionContext'); },
  clearError: () => { throw Error('Missing ExportTranscriptionContext'); },
};

const ExportTranscriptionContext = createContext<IExportTranscriptionContextValue>(
  ExportTranscriptionContextDefaultValue,
);

export default ExportTranscriptionContext;
